var setup = function(moduleId) {
	var refresh = {
		moduleId: moduleId,
		register: function(type, id) {
			var typeId = moduleId + ' ' + id;
			refresh.runtime.register(type, typeId);
		},
		signature: function() { return refresh.runtime.createSignatureFunctionForTransform(); },
		runtime: {
			createSignatureFunctionForTransform: function() { return function(type) { return type; }; },
			register: function() {}
		},
	};
	return refresh;
};

__webpack_require__.i.push(function(options) {
	var originalFactory = options.factory;
	options.factory = function(moduleObject, moduleExports, webpackRequire) {
		var hotRequire = function(request) { return webpackRequire(request); };
		var createPropertyDescriptor = function(name) {
			return {
				configurable: true,
				enumerable: true,
				get: function() { return webpackRequire[name]; },
				set: function(value) {
					webpackRequire[name] = value;
				},
			};
		};
		for (var name in webpackRequire) {
			if (name === "$Refresh$") continue;
			if (Object.prototype.hasOwnProperty.call(webpackRequire, name)) {
				Object.defineProperty(hotRequire, name, createPropertyDescriptor(name));
			}
		}
		hotRequire.$Refresh$ = setup(options.id);
		originalFactory.call(this, moduleObject, moduleExports, hotRequire);
	};
});